module.exports = {
  portfolio: [
    {
      id: 8,
      src:
        "//codepen.io/cursiv3/embed/preview/gvPoVK/?height=265&theme-id=dark&default-tab=result&embed-version=2",
      title: "FreeCodeCamp Simon Game",
      blurb:
        "This challenge was a good workout using the setTimeout and setInterval methods. Get 20 combos in a row to  win!"
    },
    {
      id: 7,
      src:
        "//codepen.io/cursiv3/embed/preview/LQprWd/?height=265&theme-id=dark&default-tab=result&embed-version=2",
      title: "FreeCodeCamp Pomodoro Clock",
      blurb:
        "Who knew implementing a simple clock that counts down would be difficult? I decided to use jQuery as I hadn't used it for a really long time."
    },
    {
      id: 6,
      src:
        "//codepen.io/cursiv3/embed/preview/OjQOKx/?height=265&theme-id=dark&default-tab=result&embed-version=2",
      title: "FreeCodeCamp Weather App",
      blurb:
        "This challenge gave me a total grasp of callback hell.  I learned the joy that are promises and this knowledge set me up for a lot of future success with consuming REST APIs."
    },
    {
      id: 4,
      src:
        "//codepen.io/cursiv3/embed/preview/xLKJje/?height=265&theme-id=dark&default-tab=result&embed-version=2",
      title: "Modern Website with React",
      blurb:
        "I built this in a couple hours to be a simple portfolio addition.  I had seen a bunch of elements and design/styling things on company sites I wanted to learn to do, so I did them here."
    },
    {
      id: 3,
      src:
        "//codepen.io/cursiv3/embed/preview/dWGqYE/?height=265&theme-id=dark&default-tab=result&embed-version=2",
      title: "Transflection Internship Solo Project",
      blurb:
        "This was a solo project I did at my internship, migrating a page from HTML/Handlebars to React."
    }
  ],
};
